import { Button, Checkbox,Box, Chip, CircularProgress, FormControl, FormHelperText, Grid, IconButton, Input, InputLabel, ListItem, ListItemIcon, MenuItem, Select, TextField, Tooltip, Typography, FormControlLabel, Switch, Stack } from  "@mui/material";
import { makeStyles } from "@mui/styles";
import { Edit as EditIcon } from '@mui/icons-material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Autocomplete } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Formik } from 'formik';
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Card } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { DataTable, Loadable } from '../../common';
import { DeleteConfirmation } from '../../common/DeleteConfirmation';
import { Portlet, PortletBody, PortletHeader, PortletHeaderToolbar } from '../../partials/content/Portlet';
import { CONTRACTED_SERVICE_OUTPATIENT, CONTRACTED_SERVICE_PROFESSIONAL, CONTRACT_STATE_FINALIZED } from '../../store/constants/contract';
import { asIsoDate } from '../../util/date';
import { ContractsSearchComponent } from '../contractsPage/ContractsSearchComponent';
import { useData } from "@pure-ptr/react";
import { getPlaceOfServiceCodes } from "../../store/api/claimAnalysis";
import debounce from 'lodash/debounce';
import { asDollarsWithZero } from "../../util/format";

const useStyles:any = makeStyles(theme => ({
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: '90%'
    },
    autoComplete: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: '90%'
    },
    formControl: {
        marginLeft: theme.spacing(1),
        width: '90%',
        marginTop: theme.spacing(2),
    },
    textArea: {
        marginLeft: theme.spacing(1),
        width: '95%',
    },
    switch: {
        margin: theme.spacing(1),
    },
    claimCharge: {
        boxShadow: '1px 1px 15px rgb(0 0 0 / 9%)',
        borderRadius: '10px',
        padding: '0px 16px 16px 16px'
    },
    deleteButton: {
        marginTop: theme.spacing(2),
        color: '#d9534f',
    },
    addModifierButton: {
        marginTop: theme.spacing(3),
    },
    chip: {
        marginTop: theme.spacing(3),
        marginLeft: '5px',
        "& span": {
            minWidth: 50
        }
    },
    buttonGrid: {
        textAlign: 'right',
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(2),
        marginBottom: theme.spacing(2),
        width: '95%'
    },
    associatedChargeError: {
        color: '#fd397a',
        fontSize: '12px',
        marginBottom: 5
    },
    redColor: {
        color: '#fd397a',
    },
    associatedChargeGrid: {
        maxHeight: '70vh',
        overflowY: 'auto'
    },
    errorText:{
        color:"red",
        fontSize:"10px",
        paddingLeft:"10px"
    },
    
    selectionIcon:{
        width:"100%",
        margin:'0 !important',
        padding:'0 !important' 
    },
    
    selectionIconButton:{
        width:"100%",
        '&:hover': {
        background: 'none !important',
    },
    },
    selectionIconButtonPayers:{
      justifyContent:'left'
    },


    selectionAutocomplete:{
        // marginLeft:"-12px",
        cursor:"pointer"
    }
}));

function ClaimEstimator({ mode, selectedClaimChargeIndex, facilities,intl, history, initialValues, cptCodes, sort, filter, order, getCPTCodesPending, fields,
    tinyContracts, associatedCharges, getAssociatedChargesPending, claimChargeData, estimatePending, estimationId, estimatorMode,brandingDetails, getBrandingPending,
    estimateById, editEstimatePending, getEstimatePending, dxCodes, dxCodesPending, payerIdMappingSettingsFlag, payerIdMappingsTiny, payerIdData,payerIdFields,
    actions: { getCPTS,resetCPTCodes, getTinyContractsByState, getAssociatedCharges, getFacilityBranding, getFacilities,
        setClaimEstimatorCharges, setSort, setOrder, estimate, setClaimChargeMode, getEstimateById, editEstimateById, 
        getDXCodes, getPayerIdMappingTiny,payerIdMappingLanding } }) {

    const [isFormRestricted, setRestrictFormSubmit] = useState(false);
    const [customChargeFieldsError, setCustomChargeError] = useState({
        cpt: false,
        revCode: false,
        associatedCharges: false,
        chargeAmount: false,
        units: false,
        serviceDate: false,
    })
    const [refresh, setRefresh] = useState(Promise.resolve());
    const [payerIdSearchText, setPayerIdSearchText] = useState("");
    const [isAddingCharge, setIsAddingCharge] = useState(false);
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [facilityError, setFacilityError] = useState(false);
    const [hasInitialBrandingFetched, setHasInitialBrandingFetched] = useState(false);

    const classes = useStyles();

    const { data:placeOfServiceCodes, isPending, error } = useData( async () => {        
        const placeOfServiceCodes = await getPlaceOfServiceCodes();
        return placeOfServiceCodes
    }, []);

    useEffect(() => {
        if (estimatorMode === 'edit' && estimateById) {
            setClaimEstimatorCharges(estimateById.chargeEstimations.map(item => {
                let modifiers = [];
                if (item.mod1) {
                    modifiers.push(item.mod1)
                }
                if (item.mod2) {
                    modifiers.push(item.mod2)
                }
                if (item.mod3) {
                    modifiers.push(item.mod3)
                }
                if (item.mod4) {
                    modifiers.push(item.mod4)
                }
                return {
                    ...item,
                    units: item.units.toString() ?? '',
                    totalChargeAmount: item.totalCharges ?? '',
                    perUnitCharge: item.perUnitCharge,
                    modifiers: modifiers,
                    cpt: item.pxCode,
                    cptDescription: item.cptDescription,
                    associatedChargeDescription: item.associatedChargeDescription ?? item.pxCodeDescription ?? item.revCodeDescription ?? '',
                }
            }))
        }
    }, [estimatorMode, estimateById, setClaimEstimatorCharges])

    useEffect(() => {
        if (estimatorMode === 'edit') {
            getEstimateById(estimationId);
        }
    }, [getEstimateById, estimationId, estimatorMode]);

    useEffect(() => {
        getFacilities();
    }, [getFacilities]);

   useEffect(() => {
    if (
        initialValues?.facilityId &&
        facilities?.length > 0 &&
        !hasInitialBrandingFetched
    ) {
        getFacilityBranding(initialValues.facilityId);
        setHasInitialBrandingFetched(true);
    }
}, [initialValues.facilityId, facilities, getFacilityBranding, hasInitialBrandingFetched]);

    useEffect(() => {
        getTinyContractsByState(CONTRACT_STATE_FINALIZED);
        return () => {
            setClaimEstimatorCharges([]);
            setClaimChargeMode('new', null);
        }
    }, [getTinyContractsByState]);

    const handleModifierDelete = (setFieldValue, modifiers, mIndex) => {
        const filteredModifiers = modifiers.filter((_, index) => index !== mIndex);
        setFieldValue(`charges.modifiers`, filteredModifiers);
    }

    const handleAddModifier = (setFieldValue, values) => {
        const updatedModifiers = [...values.charges.modifiers, values.charges.modifierField];
        setFieldValue(`charges.modifiers`, updatedModifiers);
        setFieldValue(`charges.modifierField`, '');
    }

    const handleCPTChange = useCallback((setFieldValue, value) => {
        if (value && value.code) {
            // Set all fields individually (Formik doesn't support functional updates)
            setFieldValue('charges.cpt', value);
            setFieldValue('charges.revCodeDescription', value.revCodeDescription || '');
            setFieldValue('charges.chargeAmount', value.chargeAmount || '');
            setFieldValue('charges.revCode', value.revenueCode?.toString() || '');
            setFieldValue('charges.cptDescription', value.cptDescription?.toString() || '');
            
            // Trigger associated charges API call
            getAssociatedCharges({
                pxCode: value.code,
                revCode: value.revenueCode,
               ...(value?.facilityName && { facilityName: value.facilityName, facilityId: value.facilityId }),
            });
        } else {
            // Clear all fields
            setFieldValue('charges.cpt', null);
            setFieldValue('charges.revCodeDescription', '');
            setFieldValue('charges.chargeAmount', '');
            setFieldValue('charges.revCode', '');
            setFieldValue('charges.cptDescription', '');
        }
    }, [getAssociatedCharges]);

    const handleAddToGrid = useCallback((values, setFieldValue,associatedChargesList) => {
        // Show loading immediately
        setIsAddingCharge(true);
        
        // Defer the heavy operation to allow UI to update
        setTimeout(() => {
            // Add primary associated charges to the list
            let order = 0;
            const mappedAssociatedCharges = associatedChargesList.map((item)=>{
                return {
                    ...item,
                    isPrimaryCpt: false,
                    parentCptCode: values.charges?.cpt?.code || '',
                    order: ++order
                }
            });


            const { associatedCharges, chargeAmount, cpt, modifiers, revCode, units, serviceDate, revCodeDescription, cptDescription } = values.charges;

                if (mode === 'edit') {
                const updatedChargeData = claimChargeData.map((charge, index) => {
                    if (index === parseInt(selectedClaimChargeIndex)) {
                    // units from the form (strings) → number
                    const u = parseInt(units ?? charge.units ?? '1', 10);

                    // per-unit is the Charge Amount field in the edit form
                    const perUnit = parseFloat(
                        (chargeAmount ?? charge.perUnitCharge ?? 0) as unknown as string
                    );

                    const total = Number.isFinite(u * perUnit) ? +(u * perUnit).toFixed(2) : 0;

                    return {
                        ...charge,
                        // keep the same fields, only update what's needed
                        units: u.toString(),
                        perUnitCharge: perUnit,      // drives the grid + payload
                        totalCharges: total,         // grid + payload
                        totalChargeAmount: total,    // used by your claim total reducer
                        chargeAmount: chargeAmount,  // keeps the input value in sync
                        modifiers,
                        serviceDate
                    };
                    }
                    return charge;
                });

                setClaimEstimatorCharges(updatedChargeData);
                setClaimChargeMode('new', null);
                } else {
                // validating custom fields for claim charge
                if (!cpt || !chargeAmount || !units || !serviceDate) {
                    setCustomChargeError({
                        ...customChargeFieldsError,
                        cpt: !cpt,
                        chargeAmount: !chargeAmount,
                        units: !units,
                        serviceDate: !serviceDate,
                    })
                    setIsAddingCharge(false);
                    return
                }

                const uniqId = `chargeId-${new Date().getTime()}`;
                const unitsInt = parseInt(units);
                const chargeAmountFloat = parseFloat(chargeAmount);
                const totalCharges = cpt.totalCharges ?? (unitsInt * chargeAmountFloat);

                const secondaryEstimatedCharges = [...associatedCharges, ...mappedAssociatedCharges].map(ac => {
                    return {
                        perUnitCharge: ac.perUnitCharge,
                        totalCharges: ac.totalCharges,
                        associatedChargeDescription: ac.associatedChargeDescription,
                        cpt: ac.associatedCode,
                        cptDescription: ac.associatedCptCodeDescription,
                        modifiers: [],
                        revCode: ac.associatedRevCode,
                        revCodeDescription: ac.associatedRevCodeDescription,
                        totalChargeAmount: ac.totalCharges,
                        units: ac?.averageUnits || '1',
                        serviceDate: asIsoDate(),
                        primaryId: uniqId,
                        isPrimaryCpt: ac.isPrimaryCpt || false,
                        parentCptCode: ac.parentCptCode || null,
                    };
                });
                
                //Reduce state - optimized with single state update
                setClaimEstimatorCharges(
                    [
                        ...claimChargeData,
                        {
                            displayGridKey: uniqId,
                            associatedCharges,
                            chargeAmount: chargeAmount,
                            perUnitCharge: chargeAmountFloat,
                            totalCharges,
                            associatedChargeDescription: cpt.description || '',
                            totalChargeAmount: totalCharges,
                            cpt: cpt.code,
                            cptDescription: cpt.cptDescription,
                            modifiers,
                            units,
                            serviceDate,
                            revCode: revCode,
                            revCodeDescription: revCodeDescription,
                            isPrimaryCpt: true,
                            parentCptCode: null,
                        },
                        ...secondaryEstimatedCharges
                    ]
                );
            }

            //Reset charge object fields
            setFieldValue('charges', {
                modifierField: '',
                modifiers: [],

                cpt: null,
                revCode: '',
                associatedCharges: [],
                chargeAmount: '',
                totalChargeAmount: '',
                units: '1',
                serviceDate: asIsoDate(),

                cptInputValue: ''
            });
            setCustomChargeError({
                cpt: false,
                revCode: false,
                associatedCharges: false,
                chargeAmount: false,
                units: false,
                serviceDate: false,
            })
            
            // Hide loading after operation completes
            setIsAddingCharge(false);
        }, 50); // Short delay allows UI to show loading state
    }, [mode, selectedClaimChargeIndex, claimChargeData, setClaimEstimatorCharges, setClaimChargeMode, customChargeFieldsError, setCustomChargeError]);

    const handleChargeDelete = useCallback((index) => {
        const charge = claimChargeData[index];
        
        // Show loading overlay on table
        setIsTableLoading(true);
        
        // Defer the heavy operation to allow modal to close and UI to update
        setTimeout(() => {
            if (charge.isPrimaryCpt && charge.displayGridKey) {
                // Delete primary charge and all associated secondary charges
                const filteredCharges = claimChargeData.filter(
                    item => item.displayGridKey !== charge.displayGridKey && item.primaryId !== charge.displayGridKey
                );
                setClaimEstimatorCharges(filteredCharges);
            } else {
                // Delete only the selected secondary charge by index
                const updatedCharges = [...claimChargeData];
                updatedCharges.splice(index, 1);
                setClaimEstimatorCharges(updatedCharges);
            }
            
            // Hide loading after operation completes
            setIsTableLoading(false);
        }, 300); // Longer delay allows modal animation to complete
    }, [claimChargeData, setClaimEstimatorCharges]);

    const handleEditCharge = useCallback((index, setFieldValue) => {
        // Show loading overlay on table
        setIsTableLoading(true);
        
        setClaimChargeMode('edit', index);
        setFieldValue('charges.revCode', claimChargeData[index].revCode);
        setFieldValue('charges.revCodeDescription', claimChargeData[index].revCodeDescription);
        setFieldValue('charges.chargeAmount', Number.isFinite(claimChargeData[index].perUnitCharge) ? claimChargeData[index].perUnitCharge : 0);
        setFieldValue('charges.units', claimChargeData[index].units);
        setFieldValue('charges.serviceDate', claimChargeData[index].serviceDate);
        setFieldValue('charges.cpt', claimChargeData[index].cpt);
        setFieldValue('charges.cptDescription', claimChargeData[index].cptDescription);
        
        // Hide loading immediately after setting fields
        setIsTableLoading(false);
    }, [claimChargeData, setClaimChargeMode]);

    const handleCancelEdit = (setFieldValue) => {
        setClaimChargeMode('new', null);
        setFieldValue('charges.chargeAmount', '');
        setFieldValue('charges.units', '1');
        setFieldValue('charges.revCode', '');
        setFieldValue('charges.cpt', null);
        setFieldValue('charges.modifiers', []);
        setFieldValue('charges.serviceDate', asIsoDate());
    }

    const claimChargeAction = useCallback((setFieldValue) => (_, index) => {
        return (
            <div className='d-flex'>
                <IconButton
                    color="primary"
                    className='p-1'
                    aria-label="Edit"
                    onClick={() => handleEditCharge(index, setFieldValue)}
                    size="large">
                    <Tooltip title="Edit">
                        <EditIcon />
                    </Tooltip>
                </IconButton>
                <DeleteConfirmation buttonColor='primary' handleDelete={() => handleChargeDelete(index)} />
            </div>
        );
    }, [handleEditCharge, handleChargeDelete]);

    function handleEstimate(values) {
        let claimChargePayload = claimChargeData.map((item,index) => {
            let responsePayload = {
                "cpt": item.cpt,
                "cptDescription": item.cptDescription,
                "revCode": item.revCode,
                "displayGridKey": item.primaryId || item.displayGridKey || null,
                "revCodeDescription": item.revCodeDescription,
                "chargeAmount": item.perUnitCharge,
                "totalCharges": item.totalCharges,
                "units": item.units,
                "serviceDate": item.serviceDate,
                "isPrimaryCpt": item.isPrimaryCpt || false,
                "parentCptCode": item.parentCptCode || null,
                "order": index,
                "associatedChargeDescription": item.associatedChargeDescription || null
            }
            for (let i = 0; i < item.modifiers.length; i++) {
                responsePayload[`mod${i + 1}`] = item.modifiers[i]
            }
            return responsePayload
        });
        let payload = {
            claimType: values.claimType,
            patientFName: values.patientFName,
            patientLName: values.patientLName,
            contractId: values.contractId?.id,
            facilityId: values.facilityId,
            drg: values.drg?.code,
            claimAmount: claimChargeData?.reduce((acc, curr) => acc + parseFloat(curr.totalChargeAmount), 0) || 0,
            principalDX: values.principalDX?.code ?? '',
            admitionDate: values.admitionDate,
            dischargeDate: values.dischargeDate === '' ? null : values.dischargeDate,
            estimationId: undefined,
            payerId: null,
            claimCharges: claimChargePayload,
            PlaceOfServiceCode: values.placeOfServiceCode || null,
            isSelfPayEnabled: values.isSelfPayEnabled,
            isPayerIdMappingEnabled: values.isPayerId
        };

        if (values.isPayerId && payerIdMappingSettingsFlag) {
            payload = {
                ...payload,
                contractId: null,
                payerId: values.isSelfPayEnabled ? "0" : values.estimatorPayerId?.payerId,
            }
        }
            payload = {
                ...payload,
                principalDX: values.principalDX?.code ?? values.dxInputValue
            };
        estimate(payload, handleEstimateCallback);
        
    }

    function handleEstimateCallback(payload) {
        history.push({pathname:`/estimator/history/view/${payload.estimationId}/op`,state: { from: 'estimator', estimationId: payload.estimationId }});
    }

    function handleClearFields(setFieldValue) {
        setClaimEstimatorCharges([]);
        setClaimChargeMode('new', null);
        setFieldValue('charges', {
            modifierField: '',
            modifiers: [],
            associatedCharges: [],

            cpt: null,
            cptDescription: '',
            revCode: '',
            revCodeDescription: '',
            chargeAmount: '',
            totalChargeAmount: '',
            associatedCharge: '',
            units: '1',
            serviceDate: asIsoDate(),

            cptInputValue: ''
        });
        setFieldValue('patientName', '');
        setFieldValue('claimType', '');
        setFieldValue('contractId', null);
        setFieldValue('drg', null);
        setFieldValue('claimAmount', '0');
        setFieldValue('principalDX', null);
        setFieldValue('dxInputValue', '');
        setFieldValue('admitionDate', asIsoDate());
        setFieldValue('dischargeDate', '');
        setFieldValue('isSelfPayEnabled', false);
        setFieldValue('facilityId', null);
    }

    function getClaimAmount() {
        return claimChargeData?.reduce((acc, curr) => acc + parseFloat(curr.totalCharges), 0) || 0;
    }

    const hoverData = useCallback((result) => {
        const hoverColumns = new Map();
        const cptColumns = [
            {
                label: "",
                data: result?.cptDescription
            }
        ];
        const revCodeColumns = [
            {
                label: "",
                data: result?.revCodeDescription
            }
        ];

        hoverColumns.set('cpt', cptColumns);
        hoverColumns.set('revCode', revCodeColumns);

        return hoverColumns;
    }, []);

    const handlePayerIdDropdownOpen = (event) => {
        if(event.key === 'Enter') {
            let keyword = event.target.value;
            if(keyword.length > 2) {
                getPayerIdMappingTiny({
                    keyword: keyword,
                    id: null
                });
            }
        }
    }
    const handleSetFilter = (value) => (
        {
            "operator": "and",
            "search":true,
            "operands": [
                {
                    "operator": "and",
                    "filters": [
                        {
                            "equator": "like",
                            "id": "keyword",
                            "value": value
                        }
                    ]
                }
            ]
        }
    )

    function handleLoad(sort, filter, pagination,facilityId) {
        const mergedFilter =  handleSetFilter(payerIdSearchText.length > 2 ? payerIdSearchText : '') 
        payerIdMappingLanding(pagination, sort, mergedFilter, facilityId);
    }

    function handleRefresh() {
        setRefresh(Promise.resolve());
    }

    // Memoized CPT Autocomplete functions for performance
    const cptGetOptionLabel = useCallback((option) => {
        if (!option) return '';
        if (typeof option === 'string') return option;
        
        const codePart = option?.code ? `${option.code} / ` : '';
        const chargeCodePart = option?.chargeCode ?? '';
        const descriptionPart = option?.description ? ` - ${option.description}` : '';
        const amountPart = `$ ${Number(option?.chargeAmount || 0).toFixed(2)}`;
        
        return `${codePart}${chargeCodePart}${descriptionPart} (${amountPart})`;
    }, []);

    // Memoized render function for CPT options (style objects are static)
    const cptRenderOption = useCallback((props, option) => {
        return (
            <li {...props} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <span>
                    {option?.code} / {option?.chargeCode} - {option?.description} ($
                    {Number(option?.chargeAmount || 0).toFixed(2)})
                </span>
                {option?.facilityName && (
                    <small style={{ color: '#888' }}>
                        {option?.facilityName}
                    </small>
                )}
            </li>
        );
    }, []);

    // Optimize filterOptions - limit results to prevent rendering hundreds of options
    const cptFilterOptions = useCallback((options, { inputValue }) => {
        if (!inputValue || inputValue.length < 3) {
            return options.slice(0, 50); // Show max 50 when no/short input
        }
        return options.slice(0, 100); // Show max 100 when filtering
    }, []);

    // Debounced API call to prevent flooding when typing/pasting
    const debouncedGetCPTS = useMemo(
        () => debounce((searchValue,facilityId) => {
            if (searchValue && searchValue.length > 2 && facilityId) {
                getCPTS(searchValue, facilityId);
            }
        }, 200), // Wait 200ms after last keystroke
        [getCPTS]
    );

    // Debounced DX codes API call
    const debouncedGetDXCodes = useMemo(
        () => debounce((searchValue) => {
            if (searchValue && searchValue.length > 2) {
                getDXCodes(searchValue);
            }
        }, 200), // Wait 200ms after last keystroke
        [getDXCodes]
    );

    // Memoized DataTable Component - prevents re-renders when Formik state changes
    const ClaimChargeTable = useMemo(() => {
        interface ClaimChargeTableProps {
            claimChargeData: any[];
            fields: any;
            order: any;
            setOrder: any;
            sort: any;
            setSort: any;
            hoverData: (result: any) => Map<any, any>;
            claimChargeAction: (setFieldValue: any) => (_: any, index: any) => JSX.Element;
            setFieldValue: any;
            isTableLoading: boolean;
        }
        
        return React.memo<ClaimChargeTableProps>(({ claimChargeData, fields, order, setOrder, sort, setSort, hoverData, claimChargeAction, setFieldValue, isTableLoading }) => {
            if (!claimChargeData || claimChargeData.length === 0) return null;
            
            return (
                <div className="claim-charge-table-container" style={{ 
                    maxHeight: '60vh', 
                    overflowY: 'auto',
                    overflowX: 'auto',
                    marginTop: '16px',
                    position: 'relative'
                }}>
                    <style>
                        {`
                            .claim-charge-table-container table thead {
                                position: sticky !important;
                                top: 0 !important;
                                z-index: 100 !important;
                            }
                            .claim-charge-table-container table thead tr {
                                background-color: #f5f5f5 !important;
                            }
                            .claim-charge-table-container table thead th {
                                background-color: #f5f5f5 !important;
                                box-shadow: 0 2px 4px rgba(0,0,0,0.1) !important;
                                border-bottom: 2px solid #ddd !important;
                            }
                            .table-loading-overlay {
                                position: absolute;
                                top: 0;
                                left: 0;
                                right: 0;
                                bottom: 0;
                                background-color: rgba(255, 255, 255, 0.8);
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                z-index: 200;
                            }
                        `}
                    </style>
                    {isTableLoading && (
                        <div className="table-loading-overlay">
                            <CircularProgress size={40} />
                        </div>
                    )}
                    <DataTable
                        size="small"
                        fields={fields}
                        data={claimChargeData}
                        order={order}
                        onOrder={setOrder}
                        sort={sort}
                        onSort={setSort}
                        loading={false}
                        name="Claim Charge"
                        hoverData={hoverData}
                        renderActionColumn={claimChargeAction(setFieldValue)}
                        hasActions={true}
                    />
                </div>
            );
        });
    }, []);


    return (<>
        <Loadable loading={estimatePending || editEstimatePending || getEstimatePending}>
            <Helmet title="Claim Estimator" />
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validate={values => {
                    const errors: { claimType?: string; contractId?: string; admitionDate?: string; estimatorPayerId?: string; placeOfServiceCode?: string; } = {};

                    if (!values.claimType) {
                        errors.claimType = intl.formatMessage({
                            id: "AUTH.VALIDATION.REQUIRED_FIELD"
                        });
                    }
                    if (!values.contractId && !values.isPayerId && !values.isSelfPayEnabled) {
                        errors.contractId = intl.formatMessage({
                            id: "AUTH.VALIDATION.REQUIRED_FIELD"
                        });
                    }
                    if (!values.admitionDate) {
                        errors.admitionDate = intl.formatMessage({
                            id: "AUTH.VALIDATION.REQUIRED_FIELD"
                        });
                    }
                    if(values.isPayerId && !values.isSelfPayEnabled && !values.estimatorPayerId)
                    {
                        errors.estimatorPayerId = intl.formatMessage({
                            id: "AUTH.VALIDATION.REQUIRED_FIELD"
                        });
                    }
                    if(values.claimType===CONTRACTED_SERVICE_PROFESSIONAL && !values.placeOfServiceCode)
                    {
                        errors.placeOfServiceCode = intl.formatMessage({
                            id: "AUTH.VALIDATION.REQUIRED_FIELD"
                        });
                    }

                        

                    return errors;
                }}
                
                onSubmit={(values, { setStatus, setSubmitting }) => {
                    if (claimChargeData.length === 0) {
                        setRestrictFormSubmit(true);
                        return
                    }

                    if (!values.facilityId) {
                        setFacilityError(true);
                        return;
                    }

                    setFacilityError(false);
                    handleEstimate(values)
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                }) => (

                    
                    <>
                    {brandingDetails && !brandingDetails.isSelfPayEnabled && values.isSelfPayEnabled && (
                        setFieldValue("isSelfPayEnabled", false)
                    )}
                        <form onSubmit={handleSubmit} noValidate autoComplete="off" onKeyDown={(event) => event.key === 'Enter' && event.preventDefault()}>
                            <Portlet>
                                <PortletHeader
                                    title={estimatorMode === 'edit' ? `Estimator (${estimationId})` : "Estimator"}
                                    showTitle={false}
                                    toolbar={
                                        <PortletHeaderToolbar style={{ width: '100%' }}>
                                        <Box display="flex" alignItems="center" width="100%">
                                            <Box>
                                            <FormControl size="small" style={{ minWidth: 230, maxWidth: 300 }} error={facilityError}>
                                                <InputLabel id="facility-label">Facility*</InputLabel>
                                                <Select
                                                labelId="facility-label"
                                                value={values.facilityId || ''}
                                                sx={{ '& .MuiSelect-select': { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }}
                                                MenuProps={{ PaperProps: { style: { maxWidth: 300 } } }}
                                                renderValue={(selected) => facilities?.find(f => f.id === selected)?.name || ''}
                                                onChange={(e) => {
                                                    const selectedFacilityId = e.target.value;
                                                    setFieldValue("facilityId", selectedFacilityId);
                                                    resetCPTCodes();
                                                    setClaimEstimatorCharges([]);
                                                    setFieldValue("contractId", null);
                                                    setFieldValue("estimatorPayerId", null);
                                                    setFieldValue("charges.cpt", null);
                                                    setFieldValue("charges.cptDescription", '');
                                                    setFieldValue("charges.revCode", '');
                                                    setFieldValue("charges.revCodeDescription", '');
                                                    setFieldValue("charges.chargeAmount", '');
                                                    setFieldValue("charges.associatedCharges", []);
                                                    setFieldValue("charges.cptInputValue", '');
                                                    setFacilityError(false);

                                                    if (selectedFacilityId) {
                                                        getFacilityBranding(selectedFacilityId);
                                                    }
                                                }}
                                                label="Facility"
                                                >
                                                {facilities?.map((facility) => (
                                                    <MenuItem key={facility.id} value={facility.id} style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>
                                                            {facility.name}
                                                        </MenuItem>
                                                ))}
                                                </Select>
                                                <FormHelperText>
                                                    {facilityError && "Please select a facility"}
                                                </FormHelperText>
                                            </FormControl>
                                            </Box>

                                            <Box ml="auto">
                                            <Button
                                                onClick={() => handleClearFields(setFieldValue)}
                                                variant='contained'
                                                type='button'>
                                                Clear
                                            </Button>
                                            <Button className='ml-3' variant='contained' type='submit'color="primary" disabled={!facilities || facilities.length === 0}>
                                                Estimate
                                            </Button>
                                            </Box>
                                        </Box>
                                        </PortletHeaderToolbar>
                                    }
                                />
                                <PortletBody>
                                    <Grid container>
                                        <Grid xs={9}>
                                            <Grid xs={12}>
                                                <Card>
                                                    <Card.Header as="h5">
                                                       <Stack direction="row" justifyContent="space-between" alignItems="center">
                                                        Claim Info

                                                        <Stack direction="row" alignItems="center" spacing={2}>
                                                            
                                                           {brandingDetails?.isSelfPayEnabled && (
                                                                <FormControlLabel
                                                                    label="Self Pay"
                                                                    sx={{ m: 0 }}
                                                                    control={
                                                                        <Switch
                                                                            name="isSelfPayEnabled"
                                                                            color="primary"
                                                                            className={classes.switch}
                                                                            checked={values.isSelfPayEnabled}
                                                                           onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            value={values.isSelfPayEnabled}
                                                                            sx={{
                                                                                '&.MuiSwitch-root': {
                                                                                    margin: 0
                                                                                }
                                                                            }}
                                                                        />
                                                                    }
                                                                />
                                                            )}

                                                            {payerIdMappingSettingsFlag && 
                                                                <FormControlLabel
                                                                    label="Use Payer ID Mapping"
                                                                    sx={{ m: 0 }}
                                                                    control={
                                                                        <Switch
                                                                            name="isPayerId"
                                                                            color="primary"
                                                                            className={classes.switch}
                                                                            checked={values.isPayerId}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            value={values.isPayerId}
                                                                            sx={{
                                                                                '&.MuiSwitch-root': {
                                                                                    margin: 0
                                                                                }
                                                                            }}
                                                                        />
                                                                    }
                                                                />
                                                            }

                                                        </Stack>
                                                    </Stack>
                                                    </Card.Header>
                                                    <Card.Body>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} sm={6}>
                                                                <TextField
                                                                    label="Patient First Name"
                                                                    name="patientFName"
                                                                    className={classes.textField}
                                                                    margin="normal"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={values.patientFName}
                                                                    helperText={touched.patientFName && errors.patientFName}
                                                                    error={Boolean(touched.patientFName && errors.patientFName)}
                                                                />
                                                            </Grid>
                                                            
                                                            <Grid item xs={12} sm={6}>
                                                                <TextField
                                                                    label="Patient Last Name"
                                                                    name="patientLName"
                                                                    className={classes.textField}
                                                                    margin="normal"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={values.patientLName}
                                                                    helperText={touched.patientLName && errors.patientLName}
                                                                    error={Boolean(touched.patientLName && errors.patientLName)}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                <FormControl className={classes.formControl}>
                                                                    <InputLabel htmlFor="role">Claim Type*</InputLabel>
                                                                    <Select
                                                                        required
                                                                        value={values.claimType}
                                                                        onChange={(e,val)=>{
                                                                            setFieldValue("claimType",e.target.value);
                                                                            setFieldValue("charges.placeOfServiceCode", null);
                                                                        }}
                                                                        error={Boolean(touched.claimType && errors.claimType)}
                                                                        input={<Input id="claimType" />}
                                                                        inputProps={{
                                                                            name: "claimType",
                                                                            id: "claimType"
                                                                        }}
                                                                    >
                                                                            {/* <MenuItem
                                                                                value={CONTRACTED_SERVICE_INPATIENT}
                                                                            >
                                                                                {CONTRACTED_SERVICE_INPATIENT}
                                                                            </MenuItem> */}
                                                                            <MenuItem
                                                                                value={CONTRACTED_SERVICE_OUTPATIENT}
                                                                            >
                                                                            {CONTRACTED_SERVICE_OUTPATIENT}
                                                                        </MenuItem>
                                                                            <MenuItem
                                                                                value={CONTRACTED_SERVICE_PROFESSIONAL}
                                                                            >
                                                                            {CONTRACTED_SERVICE_PROFESSIONAL}
                                                                        </MenuItem>
                                                                    </Select>
                                                                    <FormHelperText error>{touched.claimType && errors.claimType}</FormHelperText>
                                                                </FormControl>
                                                            </Grid>

                                                              {(payerIdMappingSettingsFlag && values.isPayerId && !values.isSelfPayEnabled) && (
                                                                    <Grid item xs={12} sm={6}>
                                                                        <ContractsSearchComponent
                                                                            handleSetPaginatedData={(value) => setFieldValue("estimatorPayerId", value)}
                                                                            chipBoxClass={classes.selectionIcon}
                                                                            setPaginatedSearch={setPayerIdSearchText}
                                                                            tableLoad={(sort, filter, pagination) =>
                                                                                handleLoad(sort, filter, pagination, values.facilityId)
                                                                            }
                                                                            tableData={payerIdData}
                                                                            handlePaginatedRefresh={handleRefresh}
                                                                            isKeyDownSearch={true}
                                                                            tableName="payer-id-mapping-landing"
                                                                            tableRefresh={refresh}
                                                                            tableFields={payerIdFields}
                                                                            tableTitle="payerIdMapping"
                                                                            title="Payer Id"
                                                                            isPaginatedSearch={true}
                                                                            iconButtonClass={`${classes.selectionIconButton} ${classes.selectionIconButtonPayers}`}
                                                                            icon={
                                                                                <Autocomplete
                                                                                    className={classes.autoComplete}
                                                                                    value={values.estimatorPayerId}
                                                                                    disableClearable={false}
                                                                                    onChange={(e, value) => setFieldValue("estimatorPayerId", value)}
                                                                                    isOptionEqualToValue={(option, value) => option === value}
                                                                                    options={payerIdMappingsTiny}
                                                                                    getOptionLabel={(option) => `${option.payerName} (${option.payerId})`}
                                                                                    renderInput={(params) => (
                                                                                        <TextField
                                                                                            {...params}
                                                                                            name={`estimatorPayerId`}
                                                                                            label="Payer ID*"
                                                                                            value={values?.estimatorPayerId ? `${values?.estimatorPayerId?.payerName} (${values?.estimatorPayerId?.payerId})` : ''}
                                                                                            error={Boolean(touched.estimatorPayerId && errors.estimatorPayerId)}
                                                                                            helperText={touched.estimatorPayerId && errors.estimatorPayerId}
                                                                                            placeholder='Search Payer ID/Payer Name'
                                                                                            margin="normal"
                                                                                        />
                                                                                    )}
                                                                                />
                                                                            }
                                                                        />
                                                                    </Grid>
                                                                )}

                                                                {!values.isPayerId && !values.isSelfPayEnabled && (
                                                                    <Grid item xs={12} sm={6}>
                                                                        <ContractsSearchComponent
                                                                            facilityId={values.facilityId}
                                                                            handleSetContract={(value) => setFieldValue("contractId", value)}
                                                                            chipBoxClass={classes.selectionIcon}
                                                                            iconButtonClass={`${classes.selectionIconButton} ${classes.selectionIconButtonPayers}`}
                                                                            icon={
                                                                                <Autocomplete
                                                                                    className={`${classes.autoComplete} ${classes.selectionAutocomplete}`}
                                                                                    onKeyDown={(e) => { e.preventDefault(); }}
                                                                                    open={false}
                                                                                    value={values.contractId}
                                                                                    disableClearable={false}
                                                                                    onChange={(obj, updatedContracts, event) => {
                                                                                        if (event === "clear") {
                                                                                            setFieldValue("contractId", null)                                                   
                                                                                        }
                                                                                    }}
                                                                                    isOptionEqualToValue={(option, value) => option === value}
                                                                                    options={tinyContracts}
                                                                                    getOptionLabel={(option) => option.name}
                                                                                    renderInput={(params) => (
                                                                                        <TextField
                                                                                            {...params}
                                                                                            name={`contractId`}
                                                                                            label="Contract*"
                                                                                            error={Boolean(touched.contractId && errors.contractId)}
                                                                                            helperText={touched.contractId && errors.contractId}
                                                                                            margin="normal"
                                                                                        />
                                                                                    )}
                                                                                />
                                                                            }
                                                                        />
                                                                    </Grid>
                                                                )}
                                                                                                                        

                                                            <Grid item xs={12} sm={6}>
                                                                <Autocomplete
                                                                    className={classes.autoComplete}
                                                                    value={values.principalDX}
                                                                    disableClearable={false}
                                                                    onChange={(e, value) => setFieldValue("principalDX", value)}
                                                                    isOptionEqualToValue={(option, value) => option === value}
                                                                    inputValue={values.dxInputValue}
                                                                    onInputChange={(e : any, newInputValue) => {
                                                                        // Update input immediately
                                                                        setFieldValue(`dxInputValue`, newInputValue);
                                                                        
                                                                        // Debounced API call to prevent flooding
                                                                        debouncedGetDXCodes(e?.target?.value || newInputValue);
                                                                    }}
                                                                    options={dxCodes}
                                                                    loading={dxCodesPending}
                                                                    getOptionLabel={(option) => option.description ? `${option?.code}-${option?.description}` : option?.code}
                                                                    renderInput={(params) =>
                                                                        <TextField {...params}
                                                                            name={`principalDX`}
                                                                            label="Principal DX"
                                                                            helperText={touched.principalDX && errors.principalDX}
                                                                            error={Boolean(touched.principalDX && errors.principalDX)}
                                                                            margin="normal"
                                                                            InputProps={{
                                                                                ...params.InputProps,
                                                                                endAdornment: (
                                                                                    <>
                                                                                        {dxCodesPending ? (
                                                                                            <CircularProgress color="secondary" size={20} />
                                                                                        ) : null}
                                                                                        {params.InputProps.endAdornment}
                                                                                    </>
                                                                                )
                                                                            }}
                                                                        />
                                                                    }
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                <TextField
                                                                    disabled
                                                                    type='text'
                                                                    label="Total Claim Amount"
                                                                    name="claimAmount"
                                                                    className={classes.textField}
                                                                    margin="normal"
                                                                    value={asDollarsWithZero(getClaimAmount())}
                                                                    helperText={touched.claimAmount && errors.claimAmount}
                                                                    error={Boolean(touched.claimAmount && errors.claimAmount)}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                <TextField
                                                                    type='date'
                                                                    label="Service Date*"
                                                                    name="admitionDate"
                                                                    className={classes.textField}
                                                                    margin="normal"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={values.admitionDate}
                                                                    helperText={touched.admitionDate && errors.admitionDate}
                                                                    error={Boolean(touched.admitionDate && errors.admitionDate)}
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                />
                                                            </Grid>

                                                            {values.claimType === CONTRACTED_SERVICE_PROFESSIONAL && (
                                                                <Grid item xs={12} sm={6}>
                                                                    <Autocomplete
                                                                        className={classes.autoComplete}
                                                                        value={placeOfServiceCodes?.find(option => option.code === values.placeOfServiceCode) || null}
                                                                        disableClearable={false}
                                                                        onChange={(e, value) => {
                                                                            setFieldValue(`placeOfServiceCode`, value?.code || null);
                                                                        }}                                                                        
                                                                        isOptionEqualToValue={(option, value) => option.code === value?.code}
                                                                        options={placeOfServiceCodes}
                                                                        getOptionLabel={(option) => option.name}
                                                                        renderInput={(params) =>
                                                                            <TextField {...params}
                                                                                name={`placeOfServiceCode`}
                                                                                label="Place Of Service *"
                                                                                error={Boolean(touched.placeOfServiceCode && errors.placeOfServiceCode)}
                                                                                helperText={touched.placeOfServiceCode && errors.placeOfServiceCode}
                                                                                margin="normal" 
                                                                            />
                                                                        }
                                                                    />
                                                                </Grid>                                                            
                                                            )}
                                                        </Grid>
                                                    </Card.Body>
                                                </Card>
                                            </Grid>
                                            <Grid xs={12} className='mt-4'>
                                                <Card>
                                                    <Card.Header as="h5" className={(claimChargeData.length === 0 && isFormRestricted) && classes.redColor}>Claim Charges</Card.Header>
                                                    <Card.Body>
                                                        {(claimChargeData.length === 0 && isFormRestricted) && <p className={classes.associatedChargeError}>Please add atleast one claim charge</p>}
                                                        <Grid className={`${classes.claimCharge}`}>
                                                            <Grid container>
                                                                <Grid item xs={6}>
                                                                    {mode === 'edit' ?
                                                                        <TextField
                                                                            disabled
                                                                            type='text'
                                                                            label="Procedure (CPT) / Charge Codes"
                                                                            className={classes.textField}
                                                                            margin="normal"
                                                                            // value={`${values.charges.cpt}`}
                                                                            value={values.charges.cpt === '' ? `` : `${values.charges.cpt}-${values.charges.cptDescription}`}
                                                                            InputLabelProps={{
                                                                                shrink: true,
                                                                            }}
                                                                        /> :
                                                                        <Autocomplete
                                                                            className={classes.autoComplete}
                                                                            value={values.charges.cpt}
                                                                            disableClearable={false}
                                                                            filterOptions={cptFilterOptions}
                                                                            onChange={(e, value) => handleCPTChange(setFieldValue, value)}
                                                                            isOptionEqualToValue={(option, value) => option === value}
                                                                            inputValue={values.charges.cptInputValue}
                                                                            onInputChange={(e: any, newInputValue, reason) => {
                                                                                setFieldValue(`charges.cptInputValue`, newInputValue);

                                                                                 if (!values.facilityId) return;
                                                                                // Only search when the user types (not when an option is selected/reset)
                                                                                if (reason === 'input' && newInputValue && newInputValue.length > 2) {
                                                                                    debouncedGetCPTS(newInputValue,values.facilityId);
                                                                                }
                                                                            }}
                                                                            options={cptCodes || []}
                                                                            loading={getCPTCodesPending}
                                                                            getOptionLabel={cptGetOptionLabel}
                                                                            renderOption={cptRenderOption}
                                                                            renderInput={(params) => (
                                                                                <TextField
                                                                                {...params}
                                                                                name={`charges.cpt`}
                                                                                label="Procedure (CPT) / Charge Codes"
                                                                                error={Boolean(customChargeFieldsError.cpt && !values.charges.cpt)}
                                                                                helperText={Boolean(customChargeFieldsError.cpt && !values.charges.cpt)}
                                                                                margin="normal"
                                                                                InputProps={{
                                                                                    ...params.InputProps,
                                                                                    endAdornment: (
                                                                                    <>
                                                                                        {getCPTCodesPending ? (
                                                                                        <CircularProgress color="secondary" size={20} />
                                                                                        ) : null}
                                                                                        {params.InputProps.endAdornment}
                                                                                    </>
                                                                                    ),
                                                                                }}
                                                                                />
                                                                            )}
                                                                            />

                                                                    }
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <TextField
                                                                        disabled
                                                                        type='text'
                                                                        label="Rev Code"
                                                                        name={`charges.revCode`}
                                                                        className={classes.textField}
                                                                        margin="normal"
                                                                        value={values.charges.revCode === '' ? `` : `${values.charges.revCode}-${values.charges.revCodeDescription}`}
                                                                        InputLabelProps={{
                                                                            shrink: true,
                                                                        }}
                                                                    />
                                                                </Grid>

                                                                <Grid item xs={6}>
                                                                    <TextField
                                                                        type='number'
                                                                        label="Charge Amount"
                                                                        name={`charges.chargeAmount`}
                                                                        className={classes.textField}
                                                                        margin="normal"
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        value={values.charges.chargeAmount}
                                                                        error={Boolean(customChargeFieldsError.chargeAmount && !values.charges.chargeAmount)}
                                                                        helperText={Boolean(customChargeFieldsError.chargeAmount && !values.charges.chargeAmount)}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <TextField
                                                                        label="Units"
                                                                        name={`charges.units`}
                                                                        className={classes.textField}
                                                                        margin="normal"
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        value={values.charges.units}
                                                                        error={Boolean(customChargeFieldsError.units && !values.charges.units)}
                                                                        helperText={Boolean(customChargeFieldsError.units && !values.charges.units)}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <TextField
                                                                        type='date'
                                                                        label="Service Date"
                                                                        name={`charges.serviceDate`}
                                                                        className={classes.textField}
                                                                        margin="normal"
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        value={values.charges.serviceDate ? new Date(values.charges.serviceDate).toISOString().split('T')[0] : ''}
                                                                        error={Boolean(customChargeFieldsError.serviceDate && !values.charges.serviceDate)}
                                                                        helperText={Boolean(customChargeFieldsError.serviceDate && !values.charges.serviceDate)}
                                                                        InputLabelProps={{
                                                                            shrink: true,
                                                                        }}
                                                                    />
                                                                    
                                                                </Grid>
                                                            </Grid>
                 
                                                            <Grid container>
                                                                <Grid xs={12}>
                                                                    <Stack className={classes.buttonGrid} justifyContent={'center'} alignItems={'center'} direction={'row'}>
                                                                        {mode === 'edit' &&
                                                                            <Button onClick={() => handleCancelEdit(setFieldValue)} className='mr-2'>
                                                                                Cancel
                                                                            </Button>}
                                                                        <Button
                                                                            variant='contained'
                                                                            onClick={() => handleAddToGrid({...values,isPrimaryCpt:true}, setFieldValue,associatedCharges)}
                                                                            disabled={isAddingCharge}
                                                                            startIcon={isAddingCharge ? <CircularProgress size={20} color="inherit" /> : null}
                                                                        >
                                                                            {isAddingCharge ? 'Adding...' : (mode === 'new' ? 'Add Claim Charge' : 'save')}
                                                                        </Button>
                                                                    </Stack>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>

                                                        <ClaimChargeTable 
                                                            claimChargeData={claimChargeData}
                                                            fields={fields}
                                                            order={order}
                                                            setOrder={setOrder}
                                                            sort={sort}
                                                            setSort={setSort}
                                                            hoverData={hoverData}
                                                            claimChargeAction={claimChargeAction}
                                                            setFieldValue={setFieldValue}
                                                            isTableLoading={isTableLoading}
                                                        />
                                                                                                        </Card.Body>
                                                </Card>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                </PortletBody>
                            </Portlet>
                        </form>
                    </>
                )}
            </Formik>

        </Loadable>
    </>);
}

export default ClaimEstimator


